import { createSelector } from 'reselect'

import { RootState } from '../../types'

export const selectState = createSelector(
  (s: RootState) => s.importValidation,
  b => b
)

export const areValidatedImportItemsLoading = createSelector(selectState, s => s.loading)

export const getValidatedImportItems = createSelector(selectState, s => s.data)

export const getValidatedImportId = createSelector(selectState, s => s.importId)

export const getValidatedAreAllEnabled = createSelector(selectState, s => s.data.allEnabled)
